import { PaginationAdapter } from '@red/data-access';
import { createAction, props } from '@ngrx/store';
import { InvoiceWriteoffModel } from '@shared/data-access/models';
import { IQuerySearch } from '@shared/data-access/interfaces';
// items
export const loadItems = createAction('[InvoiceWriteoff] Load items', props<{ filters: IQuerySearch }>());
export const loadItemsSuccess = createAction('[InvoiceWriteoff] Load items success', props<{ data: PaginationAdapter<InvoiceWriteoffModel> }>());

// item
export const loadItem = createAction('[InvoiceWriteoff] Load item', props<{ id: number }>());
export const loadItemSuccess = createAction('[InvoiceWriteoff] Load item success', props<{ item: InvoiceWriteoffModel }>());
